export default [
    {
        path: '/bigdata/redirect',
        name: 'bigdata-redirect',
        meta: {
            title: '万达普惠'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/bigdata/redirect.vue')),
                'bigdata-redirect'
            )
    }
]



// WEBPACK FOOTER //
// ./src/routes/bigdata.js